import { Message } from "../types/types";

export function getAllBubblesCount(messages: Message[]) {
    return messages.reduce((acc, message) => {
        return acc + message.body.length;
    }, 0);
}
